import axios from 'axios';
import {
  IRequestHistory,
  IRequestHistoryCollection,
  ICreateRequestHistoryCommentPayload,
  IRequestHistoryListParams,
  IRequestHistoryStats,
  IRequestHistoryStatsPayload,
} from 'entities/RequestHistory/RequestHistory.models';

const basePath = 'request-history';

export const requestHistoryTransport = {
  get: (params: IRequestHistoryListParams): Promise<IRequestHistoryCollection> => axios.get(`${basePath}`, { params }),
  createComment: (payload: ICreateRequestHistoryCommentPayload): Promise<IRequestHistory> =>
    axios.post(`${basePath}/comment`, payload),
  getStats: (payload: IRequestHistoryStatsPayload): Promise<IRequestHistoryStats> => axios.post(`${basePath}/stats`, payload),
};
